<template>
  <div class="task">
    <div class="header">
      <h3>照片锦集</h3>
      <span class="circle"></span>
    </div>
    <div class="task-item" v-for="item of thread" :key="`thread${item.id}`">
      <span class="content">{{item.content}}</span>
      <span class="credit">{{item.total}}学分</span>
    </div>
    <div class="header branch">
      <h3>支线任务</h3>
      <span class="circle"></span>
    </div>
    <div class="task-item" v-for="item of branch" :key="item.id">
      <span class="content">{{item.content}}</span>
      <span class="credit">{{item.total}}学分</span>
    </div>
  </div>
</template>
<script>
const branch = []
const thread = []
for (let i = 0; i < 10; i++) {
  branch.push({
    id: i,
    content: '在发现里分享段最近思考的文字',
    total: 12
  })
  thread.push({
    id: i,
    content: '在发现里分享段最近思考的文字',
    total: 12
  })
}
export default {
  data () {
    return {
      thread,
      branch
    }
  }
}
</script>
<style lang="scss" scoped>
.task {
  margin-top: 20px;
  padding: 0 16px;
  .header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin-bottom: 16px;
    h3 {
      font-size: 20px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 27px;
      margin-right: 8px;
    }
    .circle {
      width: 8px;
      height: 8px;
      border: 2px solid rgba(24, 204, 159, 1);
      border-radius: 50%;
      margin-bottom: 4px;
    }
  }
  .branch {
    margin-top: 32px;
  }
  .task-item {
    box-sizing: border-box;
    width: 100%;
    height:87px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 12px 0px rgba(0,0,0,0.1);
    padding: 12px 16px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content {
      font-size:17px;
      font-family:AlibabaPuHuiTi-Medium,AlibabaPuHuiTi;
      font-weight:500;
      color:rgba(0,0,0,1);
      line-height:23px;
      max-width: 62.68%;
      display: inline-block;
    }
    .credit {
      box-sizing: border-box;
      height:32px;
      line-height: 32px;
      text-align: center;
      background:rgba(24,204,159,1);
      padding: 6px 10px;
      font-size:14px;
      font-family:AlibabaPuHuiTi-Medium,AlibabaPuHuiTi;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:20px;
    }
  }
}
</style>
